{
  "instances": {
    "auditevents": {
      "audit_log_not_supported_spring_boot_1": "Аудирование не поддерживается для приложений на Spring Boot 1.x.",
      "event": "Событие",
      "loading_audit_events": "Загрузка событий аудита...",
      "no_audit_events_found": "События аудита не найдены.",
      "principal": "Принципал",
      "remote_address": "Адрес",
      "session_id": "Идентификатор сессии",
      "timestamp": "Время",
      "type": "Тип",
      "label": "Журнал аудита"
    }
  }
}
